import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ChatPage from "@/pages/ChatPage";
import RulesPage from "@/pages/RulesPage";
import MemoryPage from "@/pages/MemoryPage";
import CerebroPage from "@/pages/CerebroPage";
import FontesPage from "@/pages/FontesPage";
import AppsPage from "@/pages/AppsPage";
import AgentesPage from "@/pages/AgentesPage";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#080c14] text-slate-400">
        <div className="font-mono text-sm animate-pulse">a carregar memória…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <Toaster theme="dark" position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/"
            element={
              <Protected>
                <Layout />
              </Protected>
            }
          >
            <Route index element={<ChatPage />} />
            <Route path="c/:conversaId" element={<ChatPage />} />
            <Route path="rules" element={<RulesPage />} />
            <Route path="memory" element={<MemoryPage />} />
            <Route path="cerebro" element={<CerebroPage />} />
            <Route path="agentes" element={<AgentesPage />} />
            <Route path="fontes" element={<FontesPage />} />
            <Route path="apps" element={<AppsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
